import { css } from '@emotion/react';

export const selectedPersonCSS = css`
  .person-transition-enter {
    opacity: 0;
    transform: scale(0.9);
  }

  .person-transition-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms ease-in, transform 300ms ease-in;
  }

  .person-transition-exit {
    opacity: 1;
    transform: scale(1);
  }

  .person-transition-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 300ms ease-out, transform 300ms ease-out;
  }

  .person-transition-item {
    transition: all 300ms ease-in-out;
  }
`;